import { useEffect, useState } from "react";
import AssetsPack from "../../../../../util/AssetsPack";
import { SideCardType } from "../../../../../util/QuestionStatus";
import styles from "./SelectAllBar.module.css";
import { useTranslation } from "react-i18next";
import clsx from "clsx";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../store/common/hooks";
import {
  bulkDeleteSelected,
  setAllSelected,
} from "../../../../../store/conversations.slice";

const SelectAllBar = () => {
  const dispatch = useAppDispatch();
  const [checked, setChecked] = useState(false);
  const [showActionButton, setShowActionButton] = useState(false);

  const conversations = useAppSelector((s) => s.conversations.items);
  const { t } = useTranslation();

  const statusClicked = useAppSelector((s) => s.ui.statusClicked);

  useEffect(() => {
    const anySelected = conversations.some((conv) => conv.isSelected);
    const allSelected = conversations.every((conv) => conv.isSelected);
    setShowActionButton(anySelected);
    setChecked(allSelected && conversations.length > 0);
  }, [conversations]);

  const handleBulkAction = async () => {
    if (statusClicked === SideCardType.Rejected) {
      await dispatch(bulkDeleteSelected());
    }
  };
  const handleSelectAll = () => {
    dispatch(setAllSelected(!checked));
  };

  const icon = AssetsPack.icons.ICON_CLOSE.default;

  return (
    <div className={styles["all-container"]}>
      {statusClicked !== SideCardType.Context && (
        <div className={clsx(styles["select-all-box"], styles.delete)}>
          <input
            type="checkbox"
            className={clsx(styles.checkbox, styles.delete)}
            onChange={handleSelectAll}
            checked={checked}
          />
          <p>{t("selectAllBar.select_all")}</p>
        </div>
      )}

      {showActionButton && (
        <button
          className={clsx(styles["bulk-button"], styles.delete)}
          onClick={handleBulkAction}
        >
          <img src={icon} alt="" />
          {t("selectAllBar.delete_all_selected")}
        </button>
      )}
    </div>
  );
};

export default SelectAllBar;
